import * as yup from 'yup';
import {
  DaySchema,
  MonthSchema,
  YearSchema,
} from '../SignupForm/SignUpForm.schema';

export const schema = yup.object().shape({
  dobDay: DaySchema,
  dobMonth: MonthSchema,
  dobYear: YearSchema,
  privacyPolicyAgreement: yup
    .boolean()
    .required('Privacy policy is required')
    .oneOf([true], `Please confirm you have the applicant's permission.`),
});
